import { Handle, Position, type Node, type NodeProps } from '@xyflow/react';

import type { CategoryFlowNodeData } from './custom-shop-categories-flow-utils.ts';

type CategoryFlowNodeType = Node<CategoryFlowNodeData, 'category'>;

/** Nœud catégorie avec handles pour les liens parent-enfant. */
export function CategoryFlowNode({ data }: NodeProps<CategoryFlowNodeType>) {
  const showTargetHandle = data.canBeChild || data.hasParent;
  const showSourceHandle = data.canBeParent || data.hasChildren;

  return (
    <div className="min-w-[140px] rounded-lg border border-border bg-background px-4 py-2 text-center text-sm font-medium shadow-sm">
      {showTargetHandle && (
        <Handle
          id="target"
          type="target"
          position={Position.Top}
          isConnectable={data.canBeChild}
          className="!size-2 !border-border !bg-muted"
        />
      )}
      {data.label}
      {showSourceHandle && (
        <Handle
          id="source"
          type="source"
          position={Position.Bottom}
          isConnectable={data.canBeParent}
          className="!size-2 !border-border !bg-muted"
        />
      )}
    </div>
  );
}
